<template>
  <div class="container">
    <steps v-if="step !== -1" :active="step" simple style="margin-top: 20px">
      <step title="核对信息/数量"></step>
      <step title="建单完成"></step>
    </steps>
    <TpProdOrderList
      style="height: 100%;"
      v-if="step === -1"
      :routeFlag="routeFlag"
      @nexStep="nexStep"
    />
    <CheckInfo
      style="height: 100%;"
      v-if="step === 0"
      @prevStep="prevStep"
      @nexStep="nexStep"
      :selectedOrders="selectedOrders"
    />
    <CompleteOrder
      style="height: 100%;"
      v-if="step === 1"
      @nexStep="nexStep"
    />
  </div>
</template>

<script>
import {
  Steps,
  Step,
} from '@/components';
import TpProdOrderList from './list';
import CheckInfo from './check-info';
import CompleteOrder from './complete-order';

export default {
  name: 'TpProdOrder',
  components: {
    TpProdOrderList,
    CheckInfo,
    CompleteOrder,
    Steps,
    Step,
  },
  data() {
    return {
      step: -1,
      selectedOrders: [],
      routeFlag: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.routeFlag = !vm.routeFlag;
    })
  },
  methods: {
    prevStep() {
      this.step -= 1;
    },
    nexStep() {
      this.step += 1;
      if (this.step !== 0 && this.step % 1 === 0) {
        this.step = -1;
      }
    },
    select(selectedOrders) {
      this.selectedOrders = selectedOrders;
    },
  },
};
</script>

<style scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }
</style>
